import { ColumnDef } from '@tanstack/react-table';
import { Image } from '@/lib/api/images';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';

export type ImagesTableMeta = {
  onDelete: (image: Image) => void;
};

export const columns: ColumnDef<Image>[] = [
  {
    accessorKey: 'name',
    header: ({ column }) => (
      <div
        onClick={() =>
          column.toggleSorting(column.getIsSorted() == 'asc', false)
        }
      >
        Name
      </div>
    ),
    cell: ({ row }) => <div className="capitalize">{row.getValue('name')}</div>,
  },
  {
    accessorKey: 'uploadDate',
    header: ({ column }) => (
      <div
        onClick={() =>
          column.toggleSorting(column.getIsSorted() == 'asc', false)
        }
      >
        Upload Date
      </div>
    ),
    cell: ({ row }) => {
      const date = new Date(row.getValue('uploadDate'));

      return <div className="capitalize">{date.toLocaleDateString()}</div>;
    },
  },
  {
    id: 'actions',
    header: () => null,
    cell: ({ row, table }) => (
      <div className="flex justify-end">
        <Button
          variant="ghost"
          size="icon"
          onClick={(event) => {
            event.stopPropagation();
            (table.options.meta as ImagesTableMeta).onDelete(row.original);
          }}
        >
          <Trash2 className="h-4 w-4 text-destructive" />
        </Button>
      </div>
    ),
  },
];
